import { combineReducers } from "redux";
import goals from "./matches/goals";
import lineUp from "./matches/lineUp";

export default combineReducers({
    goals,
    lineUp,
});



// WEBPACK FOOTER //
// ./src/reducers/app/statistics/matches.js